import { TableCell, TableRow, Skeleton, Box } from "@mui/material";

export const LoadingRows = ({ isGlobal }: { isGlobal: boolean }) => {
    return (
        <>
            {Array.from({ length: 10 }).map((_, index) => (
                <TableRow
                    key={`loading-row-${index}`}
                    sx={{ "& td": { borderBottom: "1px solid var(--fx-surface-border, #E2E8F0)", py: 2 } }}
                >
                    {isGlobal ? (
                        <>
                            <TableCell>
                                <Skeleton variant="text" width={75} height={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={120} height={20} />
                            </TableCell>
                        </>
                    ) : (
                        <TableCell>
                            <Skeleton variant="rounded" width={110} height={24} />
                        </TableCell>
                    )}

                    <TableCell align="center">
                        <Box display="flex" justifyContent="center">
                            <Skeleton variant="text" width={95} height={20} />
                        </Box>
                    </TableCell>

                    <TableCell align="center">
                        <Box display="flex" justifyContent="center">
                            <Skeleton variant="text" width={60} height={20} />
                        </Box>
                    </TableCell>

                    {isGlobal ? (
                        <>
                            <TableCell>
                                <Skeleton variant="rounded" width={120} height={24} />
                            </TableCell>
                            <TableCell align="center">
                                <Box display="flex" justifyContent="center">
                                    <Skeleton variant="rounded" width={130} height={28} />
                                </Box>
                            </TableCell>
                        </>
                    ) : (
                        <>
                            <TableCell align="center">
                                <Box display="flex" justifyContent="center">
                                    <Skeleton variant="rounded" width={110} height={28} />
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box display="flex" justifyContent="center">
                                    <Skeleton variant="text" width={70} height={20} />
                                </Box>
                            </TableCell>
                        </>
                    )}

                    <TableCell align="right">
                        {isGlobal ? (
                            <Box display="flex" justifyContent="flex-end">
                                <Skeleton variant="text" width={70} height={20} />
                            </Box>
                        ) : (
                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                <Skeleton variant="circular" width={28} height={28} />
                                <Skeleton variant="circular" width={28} height={28} />
                            </Box>
                        )}
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
};